import React from "react";

export default function DashboardRangeTabs({
  options,
  value,
  onChange,
  shape = "full",
  className = "",
  activeClassName = "bg-[#FBBF24] text-black font-semibold",
  inactiveClassName = "text-gray-400 font-medium",
  buttonClassName = "",
}) {
  const isFull = shape === "full";

  return (
    <div
      className={`flex bg-[#1A1A1A] ${
        isFull ? "rounded-full" : "rounded-md"
      } p-1 border border-white/10 ${className}`}
    >
      {options.map((option) => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`${isFull ? "rounded-full" : "rounded-md"} ${
              isActive ? activeClassName : inactiveClassName
            } ${buttonClassName}`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
